/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { ContraceptionType } from 'app/shared/model/enumerations/contraception-type.model';
import { createEntity, getEntity, reset, updateEntity } from './sexual-history.reducer';

export const SexualHistoryUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const sexualHistoryEntity = useAppSelector(state => state.sexualHistory.entity);
  const loading = useAppSelector(state => state.sexualHistory.loading);
  const updating = useAppSelector(state => state.sexualHistory.updating);
  const updateSuccess = useAppSelector(state => state.sexualHistory.updateSuccess);
  const contraceptionTypeValues = Object.keys(ContraceptionType);

  const handleClose = () => {
    navigate(`/sexual-history${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.activeNumPartners !== undefined && typeof values.activeNumPartners !== 'number') {
      values.activeNumPartners = Number(values.activeNumPartners);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...sexualHistoryEntity,
      ...values,
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          contraception: 'CONDOM',
          ...sexualHistoryEntity,
          patient: sexualHistoryEntity?.patient?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.sexualHistory.home.createOrEditLabel" data-cy="SexualHistoryCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.sexualHistory.home.createOrEditLabel">Create or edit a SexualHistory</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sexual-history-id"
                  label={translate('tinyMedicRestApp.sexualHistory.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.solo')}
                id="sexual-history-solo"
                name="solo"
                data-cy="solo"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.partner')}
                id="sexual-history-partner"
                name="partner"
                data-cy="partner"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.currMethod')}
                id="sexual-history-currMethod"
                name="currMethod"
                data-cy="currMethod"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.currMethodSatisfaction')}
                id="sexual-history-currMethodSatisfaction"
                name="currMethodSatisfaction"
                data-cy="currMethodSatisfaction"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.pastMethodHistory')}
                id="sexual-history-pastMethodHistory"
                name="pastMethodHistory"
                data-cy="pastMethodHistory"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.sexuallyActive')}
                id="sexual-history-sexuallyActive"
                name="sexuallyActive"
                data-cy="sexuallyActive"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.activeNumPartners')}
                id="sexual-history-activeNumPartners"
                name="activeNumPartners"
                data-cy="activeNumPartners"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.newPartnerInThreeMonths')}
                id="sexual-history-newPartnerInThreeMonths"
                name="newPartnerInThreeMonths"
                data-cy="newPartnerInThreeMonths"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.contraception')}
                id="sexual-history-contraception"
                name="contraception"
                data-cy="contraception"
                type="select"
              >
                {contraceptionTypeValues.map(contraceptionType => (
                  <option value={contraceptionType} key={contraceptionType}>
                    {translate(`tinyMedicRestApp.ContraceptionType.${contraceptionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.historyOfSexualAbuse')}
                id="sexual-history-historyOfSexualAbuse"
                name="historyOfSexualAbuse"
                data-cy="historyOfSexualAbuse"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.abuseComments')}
                id="sexual-history-abuseComments"
                name="abuseComments"
                data-cy="abuseComments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.active')}
                id="sexual-history-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.draft')}
                id="sexual-history-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.cursor')}
                id="sexual-history-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.lastUpdated')}
                id="sexual-history-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.microSec')}
                id="sexual-history-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.sexualHistory.timestampEntry')}
                id="sexual-history-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="sexual-history-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.sexualHistory.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/sexual-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SexualHistoryUpdate;
